import { DISTRIBUTE_AMOUNT } from "@/config";

export const getApr = (totalStSponSupply: number | null) => {
  if (!totalStSponSupply) return 0;
  return Number(((DISTRIBUTE_AMOUNT / totalStSponSupply) * 365).toFixed(2));
};
